import { getStoredToken } from './authStorage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function buildProtectedFileUrl(fileUrl) {
  if (!fileUrl) {
    throw new Error('Arquivo inválido');
  }

  if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
    return fileUrl;
  }

  return `${BACKEND_URL}${fileUrl}`;
}

function readFilenameFromHeaders(response, fallbackName) {
  const contentDisposition = response.headers.get('content-disposition') || '';
  const match = contentDisposition.match(/filename="?([^"]+)"?/i);
  return match?.[1] || fallbackName || 'arquivo';
}

export async function openProtectedFile(fileUrl, fallbackName) {
  const token = getStoredToken();
  if (!token) {
    throw new Error('Sessão expirada. Faça login novamente.');
  }

  const targetWindow = window.open('', '_blank');
  if (targetWindow) {
    targetWindow.opener = null;
    targetWindow.document.title = fallbackName || 'Arquivo';
    targetWindow.document.body.innerHTML = '<p style="font-family: system-ui, sans-serif; padding: 16px;">Carregando arquivo...</p>';
  }

  const response = await fetch(buildProtectedFileUrl(fileUrl), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    if (targetWindow) {
      targetWindow.close();
    }
    let message = 'Não foi possível abrir o arquivo';
    try {
      const data = await response.json();
      message = data?.detail || message;
    } catch {
      // Keep the generic message when the response is not JSON.
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const filename = readFilenameFromHeaders(response, fallbackName);

  if (targetWindow) {
    targetWindow.location.assign(objectUrl);
  } else {
    const link = document.createElement('a');
    link.href = objectUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
}
